import React, { FunctionComponent } from 'react';

import Card from '@gojob/ui-bits/Card';
import Flex from '@gojob/ui-bits/Flex';
import Icon from '@gojob/ui-bits/Icon';
import InfoIcon from '@gojob/ui-bits/Icons/Info';
import usePalette from '@gojob/ui-bits/styles/PaletteProvider/usePalette';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';

export type InfoProps = {
  children: React.ReactNode;
};

const useStyles = () => {
  const { spacing, colors, boxShadow } = useTheme();
  const {
    button: { accent },
  } = usePalette();

  return {
    root: {
      display: 'inline-flex',
      position: 'relative',
      margin: spacing(6, 2, 6, 0),
      borderRadius: spacing(2),
      ':after': {
        zIndex: -1,
        content: '""',
        borderRadius: spacing(2),
        position: 'absolute',
        top: spacing(2),
        left: spacing(2),
        right: spacing(-2),
        bottom: spacing(-2),
        backgroundColor: colors[accent],
        boxShadow: boxShadow('shadow', 2),
      },
    },
  } as const;
};

const Info: FunctionComponent<InfoProps> = (props) => {
  const { children } = props;

  const classes = useStyles();
  const {
    button: { accent },
    background,
  } = usePalette();

  if (!children) {
    return null;
  }

  return (
    <Card css={classes.root} padding={[2, 4]} flexDirection="column" alignItems="center" color={background}>
      <Icon data-testid="InfoIcon" as={InfoIcon as any} color={accent} size={12} />
      <Flex margin={[0, 0, 2]}>
        <Text variant="message2">{children}</Text>
      </Flex>
    </Card>
  );
};

export default Info;
